import { render, staticRenderFns } from "./SearchByCollections.vue?vue&type=template&id=f9d88668&scoped=true"
import script from "./SearchByCollections.vue?vue&type=script&lang=js"
export * from "./SearchByCollections.vue?vue&type=script&lang=js"
import style0 from "./SearchByCollections.vue?vue&type=style&index=0&id=f9d88668&prod&scoped=true&lang=css"
import style1 from "./SearchByCollections.vue?vue&type=style&index=1&id=f9d88668&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d88668",
  null
  
)

export default component.exports